import React, { Component } from 'react';

class ReferencesList extends Component {
    render() {
        return (
            <div className={`references-list p-1 w-100`}>
                <div className="pagetitle">
                    <h1>References</h1>
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><a href="#">Home</a></li>
                            <li className="breadcrumb-item active">References</li>
                        </ol>
                    </nav>
                </div>

                <div className={` mt-4`}>
                    <div className="card">
                        <div className="card-body">
                            <div className={`d-flex justify-content-end mb-3`}>
                                <a href={'/entity/list'} className={`btn btn-primary btn-sm mr-2`}>Merchants</a>
                                <a href={'/destinations'} className={`btn btn-primary btn-sm mr-2`}>Destinations</a>
                                <a href={'/tickets/destination-tickets'} className={`btn btn-primary btn-sm`}>Tickets</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ReferencesList;